import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from "prop-types";
import { useTranslation, withTranslation } from "react-i18next";

// CodePromo Redux States
import {
  GET_CODEPROMOS,
  ADD_NEW_CODEPROMO,
  UPDATE_CODEPROMO,
} from "./actionType";

import {
  codePromoApiResponseSuccess,
  codePromoApiResponseError,

  addCodePromoFail,
  addCodePromoSuccess,
  updateCodePromoSuccess,
  updateCodePromoFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getCodePromos as getCodePromosApi,
  addNewCodePromo,
  updateCodePromo,
} from "../../helpers/fakebackend_helper";

function* getCodePromos() {
  try {
    const response = yield call(getCodePromosApi);
    yield put(codePromoApiResponseSuccess(GET_CODEPROMOS, response));
  } catch (error) {
    yield put(codePromoApiResponseError(GET_CODEPROMOS, error));
  }
}

function* onUpdateCodePromo({ payload: codePromo}) {
  console.log(codePromo);
  try {
    const response = yield call(updateCodePromo, codePromo);
    console.log(response);
    yield put(updateCodePromoSuccess(response));
  } catch (error) {
    console.log(error);
    yield put(updateCodePromoFail(error));
  }
}


function* onAddNewCodePromo({ payload: codePromo }) {
  try {
    console.log(codePromo);
    const response = yield call(addNewCodePromo, codePromo);
    yield put(addCodePromoSuccess(response));
  } catch (error) {
    yield put(addCodePromoFail(error));
  }
}

export function* watchGetCodePromos() {
  yield takeEvery(GET_CODEPROMOS, getCodePromos);
}


export function* watchUpdateCodePromo() {
  yield takeEvery(UPDATE_CODEPROMO, onUpdateCodePromo);
}

export function* watchAddNewCodePromo() {
  yield takeEvery(ADD_NEW_CODEPROMO, onAddNewCodePromo);
}

function* codePromoSaga() {
  yield all([
    fork(watchGetCodePromos),
    fork(watchUpdateCodePromo),
    fork(watchAddNewCodePromo),
  ]);
}

export default codePromoSaga;
